export const seoMetadata = {
    dev: {
        en: {
            title: 'Esmeralda Nava | Frontend Engineering Portfolio',
            description: 'Frontend engineering portfolio featuring web products, ecommerce interfaces, enterprise systems, and UX-focused development.',
        },
        es: {
            title: 'Esmeralda Nava | Portafolio Frontend Engineering',
            description: 'Portafolio frontend con productos web, interfaces ecommerce, sistemas empresariales y desarrollo enfocado en UX.',
        },
    },
    data: {
        en: {
            title: 'Esmeralda Nava | Data Analytics Portfolio',
            description: 'Data analytics portfolio focused on dashboards, reporting interfaces, data workflows, and business insight tools.',
        },
        es: {
            title: 'Esmeralda Nava | Portafolio Data Analytics',
            description: 'Portafolio de data analytics enfocado en dashboards, reportes, flujos de datos y herramientas de inteligencia de negocio.',
        },
    },
    ops: {
        en: {
            title: 'Esmeralda Nava | Ecommerce Operations Portfolio',
            description: 'Ecommerce operations portfolio featuring campaign execution, catalog experiences, storefront optimization, and commercial frontend work.',
        },
        es: {
            title: 'Esmeralda Nava | Portafolio Ecommerce Operations',
            description: 'Portafolio ecommerce operations con campanas, experiencias de catalogo, optimizacion de storefronts y frontend comercial.',
        },
    },
};

export function getSeoMetadata(profile, language) {
    return seoMetadata[profile]?.[language] || seoMetadata[profile]?.es || seoMetadata.dev.es;
}
